module.exports = __webpack_public_path__ + "static/media/noticia8.11739863.jpg";